import { useState, useEffect } from 'react';
import { supabase, isSupabaseConfigured } from '../../lib/database/supabase';
import { logger } from '../../utils/logger';

export function useSupabase() {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkSupabase = async () => {
      try {
        if (!isSupabaseConfigured()) {
          throw new Error('Supabase is not properly configured');
        }

        // Test connection with a simple query
        const { error } = await supabase.from('profiles').select('count', { count: 'exact', head: true });
        
        if (error) {
          throw error;
        }
        
        setIsReady(true);
        setError(null);
      } catch (err) {
        const message = err instanceof Error ? err.message : 'Failed to connect to database';
        logger.error('Supabase connection error:', err);
        setError(message);
        setIsReady(false);
      }
    };

    checkSupabase();
  }, []);

  return {
    supabase,
    isReady,
    error
  };
}